
import {FormAction, VisaFN, VisaFormConfig, VisaFormName} from 'src/app/shared/models/forms';
import { UserPlatformRole } from '../user';

//Model to represent the resident permit form config
export const RES_FORM_CONFIG: VisaFormConfig = {
  [VisaFormName.PERSONAL_DETAILS]: {
    version: 0.1,
    classNames: 'gap_25',
    fields: [
      {name: VisaFN.REGISTRATION_PORT_ID, type: 'select', icon: 'globe', validators: [], showInResume: true},
      {name: VisaFN.CS_IDENTIFIER, type: 'text', icon: 'id-card', validators: [], showInResume: true},
      {name: VisaFN.LAST_NAME, type: 'text', icon: 'person', validators: [], showInResume: true},
      {name: VisaFN.FIRST_NAME, type: 'text', icon: 'person', validators: [], showInResume: true},
      {name: VisaFN.BIRTH_DAY, type: 'date', icon: 'cake-candles', validators: [], showInResume: true},
      {name: VisaFN.REQUEST_REASON, type: 'select', icon: 'person', validators: [], showInResume: true},
    ]
  },
  [VisaFormName.DOCUMENT]: {
    version: 0.1,
    classNames: 'gap_10',
    disabledForSeniorities: [1],
    disabledForRoles: [UserPlatformRole.CUSTOMER, UserPlatformRole.WORKER],
    fields: [
      {name: VisaFN.PASSPORT_SCAN, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.WORK_CONTRACT, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.EMPLOYER_COMMITMENT_FORM, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.RESIDENCE_CERTIFICATE, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.LOSS_DECLARATION, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.IDENTITY_PHOTO, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE}
    ]
  }
};
